export default __webpack_public_path__ + "static/media/pie-chart.0c943193.svg";